import {useHistory, useParams} from "react-router-dom";
import styled from "styled-components";
import {useCallback, useRef} from "react";
import {useBaseCommunity, useStoreProfile} from '../../store';
import useFeedback from '../../utils/use_feedback';
import {WhiteMain} from '../../components/main';
import TopBar from '../../components/top_bar';
import {useQueue} from "../../api/content";
import {useQuery} from "../../utils/router";
import TopHeadroom from "../../components/top_headroom";
import ContentList from "../../components/content_list";
import QueueToggles from "../../components/queue_toggles";
import {NoContent} from "../profile";

const Empty = styled.div``;

const QueueList = ({community, sort, type}) => {
    const {error, feedbackCh} = useFeedback();
    const signalRef = useRef(null);
    const {content, refresh, polled, loading} = useQueue(feedbackCh, community, sort, type, signalRef);
    const {expand} = useStoreProfile();
    const history = useHistory();
    const openPost = useCallback((post) => {
        history.push(`/p/${post.uuid}`);
    }, [history]);
    if (!loading && content.length === 0) {
        return <NoContent />
    }
    return (
        <ContentList
            feedKey={`q/${community}`}
            expand={expand}
            loading={loading}
            content={content}
            loadNextPage={false}
            refresh={refresh}
            onOpenPost={openPost}
            queueContext
            signalRef={signalRef}
            polled={polled}
            noBorders
        />
    );
};

const Queue = styled(({className}) => {
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = (paramsCommunity || baseCommunity).toLowerCase();
    const {sort = "new", type = "all"} = useQuery();
    return (
        <>
            <TopBar title={'Moderation Queue'} back border />
            <WhiteMain className={className}>
                <QueueToggles activeTopic={type} />
                <QueueList community={community} sort={sort} type={type}/>
            </WhiteMain>
        </>
    );
})`
    ${Empty} {
      font-size: 15px;
      text-align: center;
    }
`;

export default Queue;
